module.exports = __webpack_public_path__ + "static/media/remove-from-classroom.e27f2e7b.svg";